import React from 'react';
import { ContactCompany, ContactDetail } from '@/search/index';
import { formatCompany } from '@/utils/index';
import { ContactList } from './ContactList';

export interface RelatedContactsSectionProps {
  /** The name of the current company */
  companyName: string;
  /** The name of the contact report */
  personName: string;
  /** Whether the related contacts by company have results */
  hasContactsByCompanyResults: boolean;
  /** The list of related contacts by company */
  relatedContactsByCompany: ContactDetail[];
  /** Whether the related contacts by company are loading */
  isLoadingContactsByCompany: boolean;
  /** Whether the related contacts by title have results */
  hasContactsByTitleResults: boolean;
  /** The list of related contacts by title */
  relatedContactsByTitle: ContactDetail[];
  /** Whether the related contacts by title are loading */
  isLoadingContactsByTitle: boolean;
  /** The handler for the click event in the company names associated with the contact */
  onCompanyClick: (
    company: string | ContactCompany,
    subsection?: string
  ) => void;
  /** The handler for the view report button */
  onViewReport: (contactId: string, subsection?: string) => void;
  /** The header component */
  header: JSX.Element;
}

/**
 * This component is responsible for displaying the related contacts section.
 */
export function RelatedContactsSection({
  companyName,
  personName,
  hasContactsByCompanyResults,
  relatedContactsByCompany,
  isLoadingContactsByCompany,
  hasContactsByTitleResults,
  relatedContactsByTitle,
  isLoadingContactsByTitle,
  onCompanyClick,
  onViewReport,
  header,
}: RelatedContactsSectionProps) {
  return (
    <>
      <ContactList
        personName={personName}
        hasResults={hasContactsByCompanyResults}
        isLoading={isLoadingContactsByCompany}
        title={`Possible Key Contacts at ${formatCompany(companyName ?? '')}`}
        contacts={relatedContactsByCompany}
        showSingleCompany
        onCompanyClick={(company) => onCompanyClick(company, 'company')}
        onViewReport={onViewReport}
        subsection="company"
        header={header}
      />

      <ContactList
        personName={personName}
        hasResults={hasContactsByTitleResults}
        isLoading={isLoadingContactsByTitle}
        title="Possible Key Contacts with Similar Job Titles"
        contacts={relatedContactsByTitle}
        onCompanyClick={(company) => onCompanyClick(company, 'title')}
        onViewReport={onViewReport}
        subsection="title"
        header={header}
      />
    </>
  );
}
